// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Cu4B","left":"styles_left__16SMP"};